import { useTheme } from '@emotion/react'

import * as styles from './loader.styles'
import { TwistoLoader } from './twisto-loader'

type Props = {
  variant?: keyof ReturnType<typeof styles.variants>
  layer?: keyof typeof styles.layers
  grayBackground?: boolean
}

export const Loader = ({
  variant = 'default',
  layer = 'default',
  grayBackground = false,
}: Props) => {
  const theme = useTheme()
  const loaderCss = [
    styles.root(theme),
    styles.variants(theme)[variant],
    styles.layers[layer],
    grayBackground && styles.grayBackground(theme),
  ]

  return (
    <div css={loaderCss} data-testid="loader">
      <TwistoLoader />
    </div>
  )
}
